import { cn } from '@shared/utils';

interface ErrorProps {
  className?: string;
  text?: string;
}

export const Error = (props: ErrorProps) => {
  if (!props.text) return null;
  return (
    <div
      className={cn('flex items-center gap-1 text-center', 'max-md:rounded-lg max-md:bg-[#e543381a] max-md:p-4 max-md:text-left', props.className)}
    >
      <div className='h-[13px] w-[12px] shrink-0 rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#ffffff]'>!</div>
      <p className='text-xs font-bold text-[#d0021b] uppercase'>{props.text}</p>
    </div>
  );
};
